import {
  API_LOGIN_SUCCESS,
  API_LOGIN_LOADING,
  API_LOGIN_FAILURE,
  API_FORGOT_SUCCESS,
  API_FORGOT_FAILURE,
  API_FORGOT_LOADING,
  API_RESET_SUCCESS,
  API_RESET_FAILURE,
  API_RESET_LOADING,
  API_UPDATEUSER_SUCCESS,
  API_UPDATEUSER_FAILURE,
  API_UPDATEUSER_LOADING
} from './constants';
import api from '../api';
import { apiDataSuccess } from './basket';

export function apiLoginFailure(bool, data) {
  return {
    type: API_LOGIN_FAILURE,
    hasFailed: bool,
    data
  };
}

export function apiLoginIsLoading(bool) {
  return {
    type: API_LOGIN_LOADING,
    isLoading: bool
  };
}

export const apiLoginSuccess = data => ({
  type: API_LOGIN_SUCCESS,
  data
});

export const apiForgotSuccess = data => ({
  type: API_FORGOT_SUCCESS,
  data
});

export function apiForgotFailure(data) {
  return {
    type: API_FORGOT_FAILURE,
    data
  };
}

export function apiForgotIsLoading(bool) {
  return {
    type: API_FORGOT_LOADING,
    isLoading: bool
  };
}

export const apiResetSuccess = data => ({
  type: API_RESET_SUCCESS,
  data
});

export function apiResetFailure(data) {
  return {
    type: API_RESET_FAILURE,
    data
  };
}

export function apiResetIsLoading(bool) {
  return {
    type: API_RESET_LOADING,
    isLoading: bool
  };
}

// updateUser

export const apiUpdateUserSuccess = data => ({
  type: API_UPDATEUSER_SUCCESS,
  data
});

export function apiUpdateUserFailure(data) {
  return {
    type: API_UPDATEUSER_FAILURE,
    data
  };
}

export function apiUpdateUserIsLoading(bool) {
  return {
    type: API_UPDATEUSER_LOADING,
    isLoading: bool
  };
}

export const postLoginData = (id, user) => dispatch => {
  const login = {
    user,
    basket: {
      id
    }
  };
  dispatch(apiLoginIsLoading(true));
  return api.auth
    .login(login)
    .then(response => {
      if (response.result === 'error' || response.status_description === 'Not Found') {
        dispatch(apiLoginIsLoading(false));
        throw Error(response.message);
      }
      if (
        response.status_code === 400 ||
        response.status_code === 401 ||
        response.status_description === 'Bad Request'
      ) {
        dispatch(apiLoginIsLoading(false));
        throw response.error_messages[0];
      }
      dispatch(apiLoginIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiLoginSuccess(response)))
    .catch(res => dispatch(apiLoginFailure(true, res)));
};

export const forgotPassword = (id, user) => dispatch => {
  const credentials = {
    basket: {
      id
    },
    user: user
  };
  dispatch(apiForgotIsLoading(true));

  return api.auth
    .forgot(credentials)
    .then(response => {
      if (response.status_code !== 200) {
        dispatch(apiForgotIsLoading(false));
        throw response.error_messages;
      }
      dispatch(apiForgotIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiForgotSuccess(response)))
    .catch(res => dispatch(apiForgotFailure(res)));
};

export const resetPassword = (id, user) => dispatch => {
  const credentials = {
    basket: {
      id
    },
    user: user
  };

  dispatch(apiResetIsLoading(true));

  return api.auth
    .reset(credentials)
    .then(response => {
      if (!(response.status_code === 202 || response.status_code === 200)) {
        dispatch(apiResetIsLoading(false));
        throw response.error_messages;
      }
      dispatch(apiResetIsLoading(false));
      return response;
    })
    .then(response => {
      dispatch(apiResetSuccess(response));
      dispatch(apiDataSuccess(response));
    })
    .catch(res => dispatch(apiResetFailure(res)));
};

export const updateUser = (id, user) => dispatch => {
  const update = { user: { id, ...user } };
  dispatch(apiUpdateUserIsLoading(true));
  return api.auth
    .update(update)
    .then(response => {
      if (response.result === 'error' || response.status_description === 'Not Found') {
        dispatch(apiUpdateUserIsLoading(false));
        throw Error(response.error_messages[0]);
      }
      if (
        response.status_code === 400 ||
        response.status_code === 401 ||
        response.status_description === 'Bad Request'
      ) {
        dispatch(apiUpdateUserIsLoading(false));
        throw response.error_messages[0];
      }
      dispatch(apiUpdateUserIsLoading(false));
      return response;
    })
    .then(response => {
      dispatch(apiUpdateUserSuccess(response));
      // return dispatch(apiDataSuccess(response));
    })
    .catch(res => dispatch(apiUpdateUserFailure(res)));
};



// WEBPACK FOOTER //
// ./src/actions/login.js